import React from 'react';

const LoadingOverlay = ({ message = "Updating Product..." }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Glass overlay */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      
      {/* Content container */}
      <div className="relative bg-white/90 rounded-2xl p-8 shadow-2xl max-w-sm w-full mx-4 transform transition-all">
        {/* Loading animation */}
        <div className="flex justify-center mb-4">
          <div className="relative w-16 h-16">
            <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
            <div className="absolute top-0 left-0 w-full h-full border-4 border-blue-500 rounded-full animate-spin border-t-transparent"></div>
          </div>
        </div>
        
        {/* Message */}
        <div className="text-center">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">{message}</h3>
          <p className="text-gray-600">Please wait while we process your request...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay; 